import * as React from 'react';

export const LoyaltyPlatinumIcon = ({ width = 37, height = 40 }: { width?: number; height?: number }) => (
    <svg
        style={{ flexShrink: 0 }}
        width={width}
        height={height}
        viewBox="0 0 37 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.5689 0.48449C17.7034 -0.163439 19.0958 -0.16344 20.2303 0.484489L34.5389 8.65641C35.6895 9.31352 36.3996 10.5369 36.3996 11.8619V28.1367C36.3996 29.4617 35.6895 30.685 34.5389 31.3421L20.2303 39.5141C19.0958 40.162 17.7034 40.162 16.5689 39.5141L2.26033 31.3421C1.10975 30.685 0.399612 29.4617 0.399612 28.1366V11.8619C0.399612 10.5369 1.10975 9.31353 2.26033 8.65641L16.5689 0.48449Z"
            fill="url(#paint0_linear_2516_32625)"
        />
        <path
            d="M11.5562 16.1749L14.6801 17.9173L17.7943 14.2695C18.0331 13.9898 18.4977 13.925 18.832 14.1248C18.8988 14.1647 18.9572 14.2136 19.005 14.2695L22.1192 17.9173L25.243 16.1749C25.5849 15.9842 26.0467 16.0615 26.2747 16.3475C26.3726 16.4705 26.4151 16.6187 26.3945 16.7655L25.1721 25.4591C25.128 25.7725 24.8105 26.0088 24.4333 26.0088H12.366C11.9888 26.0088 11.6713 25.7725 11.6272 25.4591L10.4048 16.7655C10.3568 16.4241 10.6486 16.1148 11.0567 16.0746C11.2321 16.0573 11.4092 16.0929 11.5562 16.1749Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2516_32625"
                x1={18.3996}
                y1={-0.0014568}
                x2={34.0144}
                y2={51.9797}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#141E30" />
                <stop offset={1} stopColor="#28416F" />
            </linearGradient>
        </defs>
    </svg>
);
